import { IMAGE_RESOLUTIONS } from 'components/HomepageCarousel/Carousel/constants'
import { useSpringboardCarouselData } from '../hooks'
import { SpringboardCarouselTile } from './SpringboardCarouselTile'

const imageWidth = IMAGE_RESOLUTIONS.md.width * 2
const imageHeight = IMAGE_RESOLUTIONS.md.height * 2

export const SingleColumnSpringboardCarousel = () => {
  const carouselSpringboardItems = useSpringboardCarouselData()

  return carouselSpringboardItems
    .concat(carouselSpringboardItems)
    .map((item, index) => (
      <div
        className='mc-mb-3'
        key={item.slug + index}
        style={{
          transform: 'translateY(0%)', // Ensures the nameplateImage is anchored to its tile
        }}
      >
        <SpringboardCarouselTile
          uuid={item.uuid}
          itemType={item.itemType}
          imageURL={item.carouselImageURL}
          height={imageHeight}
          width={imageWidth}
          title={item.title}
          nameplateImage={item.nameplateImage}
          categoryId={item.primaryCategory?.id}
          slug={item.slug}
        />
      </div>
    ))
}
